import React from 'react';

const AccountedRecordsRow = ({accountedRecords, title = 'Учтенные в прошлых реестрах записи:', cl}) => {
  if(accountedRecords && accountedRecords.length>0){
    return <>
      {title}
      <div className={'d-flex flex-wrap '+(cl || '')}>
        {accountedRecords.map((item, index)=>{
          return <div className={'w-50'} key={index}>
            {item.BSO} на сумму {item.total} в {item.operation}
          </div>
        })}
      </div>

    </>
  }
};

export default AccountedRecordsRow;
